import React from 'react';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import BrightnessAutoIcon from '@mui/icons-material/BrightnessAuto';
import { ThemePreference } from '../types';

export const NEXT_THEME_PREFERENCE: Record<ThemePreference, ThemePreference> = {
	[ThemePreference.Light]: ThemePreference.Dark,
	[ThemePreference.Dark]: ThemePreference.Auto,
	[ThemePreference.Auto]: ThemePreference.Light,
};

export const THEME_PREFERENCE_DISPLAY: Record<ThemePreference, {icon: React.ReactNode; label: string}> = {
	[ThemePreference.Light]: {icon: <LightModeIcon fontSize='small' />, label: 'Light mode'},
	[ThemePreference.Dark]: {icon: <DarkModeIcon fontSize='small' />, label: 'Dark mode'},
	[ThemePreference.Auto]: {icon: <BrightnessAutoIcon fontSize='small' />, label: 'Auto mode'},
};
